import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { number } from "yup";

import { IIndividualJob } from "../../services/non-member/jobsAPI";

export interface IApplicationFilterSlice {
  location: string[];
  industry: string[];
  jobs: IIndividualJob[];
  salary: string[];
  experience: string[];
  // isLookingForSalaryAboveBaseRange: boolean;
  // isLookingForExperienceAboveBaseRange: boolean;
}

interface ISetFilterPayload {
  type: keyof IApplicationFilterSlice;
  selectedValues: string | string[] | boolean | number[];
}

const applicationsFilterSlice = createSlice({
  name: "applicantFilter",
  initialState: {
    location: [],
    industry: [],
    jobs: [],
    salary: [],
    experience: [],
    isLookingForSalaryAboveBaseRange: false,
    isLookingForExperienceAboveBaseRange: false,
  } as IApplicationFilterSlice,
  reducers: {
    setApplicantFilter: (
      state,
      {
        payload: {
          type,
          selectedValues,
          reset = false,
          typeOfInsertion = "fresh",
        },
      }: PayloadAction<{
        type: keyof IApplicationFilterSlice;
        selectedValues:
          | string
          | string[]
          | boolean
          | IIndividualJob[]
          | number[];
        reset?: boolean;
        typeOfInsertion?: "fresh" | "concat";
      }>
    ) => {
      if (reset) {
        state.location = [];
        state.industry = [];
        state.jobs = [];
      } else {
        if (type === "jobs") {
          if (typeOfInsertion === "fresh") {
            state.jobs = [...(selectedValues as IIndividualJob[])];
          } else {
            state.jobs = [
              ...state.jobs,
              ...(selectedValues as IIndividualJob[]),
            ];
          }
        } else if (type === "salary" || type === "experience") {
          state[type] = [...(selectedValues as string[])];
        } else {
          (state[type] as any) = selectedValues;
        }
      }
    },
    setFilterAdhoc: (
      state,
      {
        payload: { industry, experience, isLookingForExperienceAboveBaseRange },
      }: PayloadAction<{
        experience?: string[];
        industry?: string[];
        isLookingForExperienceAboveBaseRange?: boolean;
      }>
    ) => {
      if (industry) state.industry = industry;
      if (experience) state.experience = experience;
      // if (isLookingForExperienceAboveBaseRange)
      //   state.isLookingForExperienceAboveBaseRange =
      //     isLookingForExperienceAboveBaseRange;
    },

    clearApplicantFilters: (state) => {
      state.location = [];
      state.industry = [];
      state.jobs = [];
      state.experience = [];
      state.salary = [];
    },
  },
});

export const { setApplicantFilter, clearApplicantFilters, setFilterAdhoc } =
  applicationsFilterSlice.actions;

export default applicationsFilterSlice.reducer;
